import { gql } from '@apollo/client';

const MARK_ALL_CLINIC_NOTIFICATIONS_AS_READ = gql`
  mutation markAllClinicNotificationsAsRead {
    markAllClinicNotificationsAsRead {
      isSuccess
      message
    }
  }
`;

export default MARK_ALL_CLINIC_NOTIFICATIONS_AS_READ;
